// src/pages/customers/CustomerAddresses/CustomerAddressListPage.jsx
import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { CustomerAddressesAPI, CustomersAPI } from '../../../api/v3/customers-api-v3';
import AddressCard from '../../../components/customers/AddressCard';

const BASE = '/app/sales/bagspa';

export default function CustomerAddressListPage() {
  const { customerId } = useParams();
  const [customer, setCustomer] = useState(null);
  const [rows, setRows] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    (async () => {
      try {
        const c = await CustomersAPI.show(customerId);
        setCustomer(c?.item || c?.data || c);
        const a = await CustomerAddressesAPI.list(customerId);
        setRows(a?.items || a?.data || a || []);
      } catch (e) { setError(e.message); }
    })();
  }, [customerId]);

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2 className="mb-0">Addresses — Customer #{customerId} {customer?.name ? `(${customer.name})` : ''}</h2>
        <div>
          <Link className="btn btn-light mr-2" to={`${BASE}/customers/${customerId}`}>Back to Customer</Link>
          <Link className="btn btn-primary" to={`${BASE}/customers/${customerId}/addresses/new`}>+ New</Link>
        </div>
      </div>
      {error && <div className="alert alert-danger">{error}</div>}
      {rows.length === 0 ? <div className="text-muted">No addresses</div> : rows.map(a => (
        <Link key={a.id} to={`${BASE}/customers/${customerId}/addresses/${a.id}`} className="text-reset text-decoration-none">
          <AddressCard address={a} />
        </Link>
      ))}
    </div>
  );
}
